import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    api.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("err"));
  }, [params]);

  return (
    <AuthShell title="Ověření e-mailu">
      {status === "loading" && <p className="text-muted-foreground">Ověřuji…</p>}
      {status === "ok" && <p data-testid="verify-ok" className="text-emerald-500 font-semibold">E-mail byl úspěšně ověřen. <Link to="/" className="text-brand underline">Pokračovat</Link></p>}
      {status === "err" && <p data-testid="verify-err" className="text-destructive">Neplatný nebo expirovaný odkaz.</p>}
    </AuthShell>
  );
}
